import React from "react";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getResult = () => {
    const wp_entries = this.props.entries;
    let result = [];
    let input = this.props.keyword.toLowerCase();
    let keyword = input;

    // 先頭か末尾にスペースがある場合は取り除く
    if (input.match(/^\s/)) {
      //alert('Space included in Head');
      keyword = input.replace(/^\s/, "");
    }
    if (input.match(/\s$/)) {
      //alert('Space included in Bottom');
      keyword = input.replace(/\s$/, "");
    }

    // 入力値を半角スペースで分割して配列に格納
    let separator = /\s+/;
    let keywords = keyword.split(separator);

    if (keywords[0]) {
      for (let i = 0; i < wp_entries.length; i++) {
        /*2019.07.31 k.yamada | titleで "toLowerCase() is not function" エラーが発生した為、から文字を加え明示的に文字列に変換処理を加える*/
        /*2019.07.31 k.yamada | Audition名でも検索を可能にする為catを追加*/
        //let id = (wp_entries[i].id+"").toLowerCase()
        //let category = (wp_entries[i].cat+"").toLowerCase()
        let title = (wp_entries[i].title + "").toLowerCase();
        let author = (wp_entries[i].author + "").toLowerCase();
        let country = (wp_entries[i].country + "").toLowerCase();
        //let award = (wp_entries[i].award+"").toLowerCase()
        //let viewer_url = (wp_entries[i].slug+"").toLowerCase()
        let cat = (wp_entries[i].cat + "").toLowerCase();

        //if( keywords.indexOf(id) >= 0 || keywords.indexOf(title) >= 0 || keywords.indexOf(author) >= 0 || keywords.indexOf(country) >= 0 || keywords.indexOf(category) >= 0 ){

        for (let n = 0; n < keywords.length; n++) {
          if (
            title.match(keywords[n]) ||
            author.match(keywords[n]) ||
            country.match(keywords[n]) ||
            cat.match(keywords[n])
          ) {
            //console.log('match:' + id + ' ' + title + ' by ' + author);
            result.push(wp_entries[i]);
          }
        }
      }
    }

    return result;
  };

  render() {
    return (
      <>
        <ul className="search_list">
          Results:
          <h2 style={{ fontWeight: "bold" }}>
            Keyword: <span style={{ color: "#FF0000" }}>{this.props.keyword}</span>
          </h2>
          {this.getResult().map((entry) => {
            return (
              <li>
                <a href={entry.slug} target="_blank" rel="noopener">
                  [{entry.cat}] “{entry.title}” by {entry.author} ({entry.country}/id:{entry.id})
                  <p className="btn_read">READ</p>
                </a>
              </li>
            );
          })}
        </ul>
      </>
    );
  }
}

export default Search;
